<template>
  <div class="message-body message-button">
    <div class="general-button button-ask-information">
      <div class="widget-button-header">
        <div class="widget-button-header-desc">
          {{ question }}
        </div>
        <ul class="widget-button-list">
          <li>
            <div class="form-style" :class="sending || success ? 'disable' : ''">
              <input type="text" v-model="answer" class="text" :placeholder="askInfo.ask_info.placeholder">
              <button class="button-form-submit color-theme-default" :class="[success ? 'sucsess' : '', error ? 'error' : '']" @click.stop="sendAnswer">
                <i v-if="!sending && !success && !error" class="backto-list-icon forward"></i>
                <i v-if="sending" class="spinner"></i>
                <v-icon v-if="success" name="check" />
                <v-icon v-if="error" name="undo" />
              </button>
            </div>
            <div v-if="error" class="text-alert">{{ error }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const objectPath = require('object-path')

export default {
  name: 'ask-info',
  props: ['askInfo', 'messageId', 'answered'],

  data () {
    return {
      answer: '',
      sending: false,
      success: false,
      error: ''
    }
  },

  computed: {
    question () {
      const inputType = objectPath.get(this.askInfo, 'ask_info.input_type', '')
      let question = ''

      if (inputType === 'phone') {
        question = this.$t('question_phone')
      } else if (inputType === 'email') {
        question = this.$t('question_email')
      } else {
        question = objectPath.get(this.askInfo, 'ask_info.question', '')
      }

      return question
    }
  },

  created () {
    if (this.answered) {
      this.success = true
      this.sending = false
      this.error = ''
      this.answer = objectPath.get(this.askInfo, 'ask_info.answer', '')
    }
  },

  methods: {
    sendAnswer () {
      // input_type: phone, email, text, password, number, data, color, location, time, url

      if (this.sending || this.success) {
        return false
      }

      if (!this.answer) {
        this.error = this.$t('error_empty')
        return false
      }

      this.sending = true
      this.error = ''

      this.$parent.$emit('answer', {
        messageId: this.messageId,
        askInfo: this.askInfo,
        answer: this.answer
      })
    }
  },

  watch: {
    answered (answered) {
      if (!answered) return
      this.success = true
      this.sending = false
      this.error = ''
    }
  }
}
</script>
